import { moveElementInArray } from "./global";
import { v4 as uuidv4 } from 'uuid';
import { type Scene, SceneKinds } from "./Soundboard";
import { type CardKind, CardKinds, SoundCard } from "./SoundCard";
import { DEFAULT_SOUNDCARD_VOLUME, DEFAULT_SOUNDCARD_ENABLED, DEFAULT_SOUNDCARD_PLAY_SETTINGS } from './lib/constants';

export class FreeformScene implements Scene {
    id: string;
    name: string;
    kind: string = SceneKinds.Freeform;
    cards: Array<SoundCard>;
    card_indices: Map<string, number>;
    permalinkId: string;

    constructor(rawData: any) {
        this.id = rawData.id;
        this.name = rawData.name;
        this.cards = rawData.cards.map((rawCard) => {
            const volume = rawCard.volume !== undefined ? rawCard.volume : DEFAULT_SOUNDCARD_VOLUME;
            const enabled = rawCard.enabled !== undefined ? rawCard.enabled : DEFAULT_SOUNDCARD_ENABLED;
            const playSettings = rawCard.playSettings !== undefined ? rawCard.playSettings : {
                repeat: null,
                volume,
                enabled,
            };
            return SoundCard.fromRaw(rawCard.name, rawCard.id, rawCard.sound, CardKinds.Plain, playSettings);
        })
        this.card_indices = new Map(this.cards.map((card, idx) => [card.id, idx]))
        this.permalinkId = rawData.permalinkId !== undefined ? rawData.permalinkId : this.id;
    }
    RehashIds() {
        this.id = uuidv4();
        for (let i = 0; i < this.cards.length; i++) {
            this.cards[i].id = uuidv4();
        }
        this.updateCardIndices();
    }
    ContainsSound(soundId: string): boolean {
        return this.cards.findIndex((card) => card.sound.id == soundId) !== -1;
    }
    DeleteCard(cardId: string) {
        const index = this.card_indices.get(cardId);
        this.cards.splice(index, 1);
        this.card_indices.delete(cardId);
        this.updateCardIndices();
    };
    GetCard(cardId: string): SoundCard {
        const index = this.card_indices.get(cardId);
        return this.cards[index]
    }
    AddCard(title: string, rawSound: any, kind: CardKind) {
        const id = uuidv4();
        const card = SoundCard.fromRaw(title, id, rawSound, kind, DEFAULT_SOUNDCARD_PLAY_SETTINGS);
        const idx = this.cards.length;
        this.cards.push(card);
        this.card_indices.set(id, idx);
    }

    MoveCardInScene(oldIdx, newIdx) {
        moveElementInArray(this.cards, oldIdx, newIdx)
        this.updateCardIndices();
    }

    Permalink(): string {
        return `${window.location.origin}/app/soundboard#${this.permalinkId}`
    }

    RehashPermalinkIds() {
        this.permalinkId = uuidv4();
    }

    AllCards(): SoundCard[] {
        return this.cards;
    }

    updateCardIndices() {
        this.card_indices = new Map();
        this.cards.forEach((card, idx) => {
            this.card_indices.set(card.id, idx)
        })
    }

    getCardAtIdx(idx: number): SoundCard {
        return this.cards[idx]
    }
}